import { styled, Box } from "@mui/material";

export const ScrollableWrapperRoot = styled(Box)(({ theme }) => ({
  display: "block",
}));

export const OptionsContentWrapper = styled(Box)(({ theme, row }) => ({
  margin: "auto",
  zIndex: 2,
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  overflowX: "auto",
  gap: "1rem",
  boxSizing: "border-box",
  padding: "1rem 2rem",
  marginBottom: "0.4rem",
  flexWrap: "wrap",
  width: "auto",
  maxWidth: "100%",
  [theme.breakpoints.down("lg")]: {
    padding: "1rem 2rem",
  },
  [theme.breakpoints.down("md")]: {
    width: "auto",
    padding: "1rem 3rem",
    gap: "1.5rem",
  },
  "&::-webkit-scrollbar-track": {
    marginRight: "1.2rem",
    marginLeft: "1.2rem",
    background: "rgba(255,255,255,0.1)",
  },
  "&::-webkit-scrollbar": {
    height: "0.2rem",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "white",
  },
}));
